// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InnerContainerWrapper_wrapper__27azT"};